// DTOs for Workflow operations
export var WorkflowActionDefinitionId;
(function (WorkflowActionDefinitionId) {
    WorkflowActionDefinitionId["HANDOFF"] = "HANDOFF";
    WorkflowActionDefinitionId["LINK_SEND"] = "LINK_SEND";
    WorkflowActionDefinitionId["CUSTOM"] = "CUSTOM";
})(WorkflowActionDefinitionId || (WorkflowActionDefinitionId = {}));
export var WorkflowActionType;
(function (WorkflowActionType) {
    WorkflowActionType["PHONE_CALL"] = "PHONE_CALL";
    WorkflowActionType["EMAIL"] = "EMAIL";
    WorkflowActionType["SMS"] = "SMS";
    WorkflowActionType["PUSH_INTEGRATION"] = "PUSH_INTEGRATION";
    WorkflowActionType["TRANSFER"] = "TRANSFER";
})(WorkflowActionType || (WorkflowActionType = {}));
export var ActionSubtype;
(function (ActionSubtype) {
    ActionSubtype["WORK_ORDER"] = "WORK_ORDER";
    ActionSubtype["SERVICE_REQUEST"] = "SERVICE_REQUEST";
    ActionSubtype["GUEST_CARD"] = "GUEST_CARD";
    ActionSubtype["TASK"] = "TASK";
    ActionSubtype["TICKET"] = "TICKET";
})(ActionSubtype || (ActionSubtype = {}));
// Generic filter condition types — used by scenarios, workflows, handoffs, and any
// other surface that gates on property / group / office-hours.
export var FilterField;
(function (FilterField) {
    // One condition owns property scope as a whole: match ANY listed property
    // OR ANY listed group (groups resolve to member properties live at
    // evaluation time). Both empty = unscoped.
    FilterField["PROPERTY_SCOPE"] = "property.scope";
    FilterField["GROUP_TYPES"] = "group.types";
    FilterField["OFFICE_HOURS"] = "schedule.officeHours";
})(FilterField || (FilterField = {}));
export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["EQUALS"] = "equals";
    FilterOperator["IN"] = "in";
    FilterOperator["NOT_IN"] = "not_in";
})(FilterOperator || (FilterOperator = {}));
export var OfficeHoursMode;
(function (OfficeHoursMode) {
    OfficeHoursMode["ALWAYS"] = "ALWAYS";
    OfficeHoursMode["BUSINESS_HOURS"] = "BUSINESS_HOURS";
    OfficeHoursMode["AFTER_HOURS"] = "AFTER_HOURS";
    OfficeHoursMode["CUSTOM_HOURS"] = "CUSTOM_HOURS";
})(OfficeHoursMode || (OfficeHoursMode = {}));
//# sourceMappingURL=workflow-dtos.js.map